import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import mathis from "../assets/bebe/mathis.jpg"
import louna from "../assets/bebe/louna.jpg"
import mariloue from "../assets/bebe/mariloue.jpg"
import tc from "../assets/bebe/tc.jpg"
import img1 from "../assets/img/bandeau.jpg";

export const Nouveau = () => {
  return (
    <>

      <div className="banner-titre-container">
        <img src={img1} className="back-img" />
        <div className='over-banner'>
          <div className='info-banner'>
            <h1 className='banner-title'> Bienvenue sur Terre petit ange ...</h1>
          </div>
        </div>
      </div>

      <div className='block-container bottom-space side-space-margin top-space-margin'>
        <Row>
          <Col xs={12} lg={9}>
            <div className='central-block central-block-margin'>
              <h2 className='contact-titre meditation-titre'> Accueil des nouveau-nés : Bébé-Channeling </h2>
              <p >
                <br /><br />
                <div className='meditation-titre'><strong><em style={{ fontWeight: 500, fontSize: '20px' }}>"Petit Prince, d'où viens-tu ?" </em></strong>
                  <strong><em style={{ fontWeight: 500, fontSize: '20px' }}>"Je viens d'une planète lointaine ..."</em></strong>  <br /><br />
                  &nbsp; </div>
                Et si votre enfant aussi venait d'un autre monde ? S'il vous avait choisi comme parents, pour l'aider à évoluer ? <br /><br />
                Tout comme <strong>l’échographie prénatale</strong> fournit depuis les années 80 un <strong>diagnostic</strong> précis de la <strong>santé physique</strong> du bébé, le <strong>Bébé Channeling</strong> permet aujourd’hui de <strong>se familiariser</strong> avec la <strong>personnalité</strong> spécifique de votre enfant.
                <br /><br /> En tant que <strong>Channel Spirituel et Berceuse à l'Hôpital</strong>, il m'est donné, par un doux contact <strong>d'âme à âme</strong>, de recueillir les <strong>messages de votre enfant</strong> à naître ou déjà né : c'est lui qui me confie ses espoirs, ses besoins, ses appréhensions, son but d'incarnation.
                <br /><br /> <strong>Accepter d'écouter</strong> votre enfant, c’est mieux le <strong>comprendre</strong> et l’<strong>accompagner</strong> au long de son développement.
                <br /><br /> Le <strong>Bébé-Channeling</strong> est une <strong>expérience tendre et joyeuse</strong>. Vous pourrez enregistrer les <strong>précieuses informations</strong> dans un petit livret de naissance… à relire plus tard pour revivre l’émotion du premier échange.

                <br /><br /> <strong>Avant la naissance, </strong>le<strong> Bébé-Channeling</strong> permet  : <br /> <br />
                <ul>
                  <li>de ressentir la personnalité spécifique de votre enfant
                  </li>
                  <li>d’être orienté vers des sonorités de prénoms en harmonie avec sa vibration
                  </li>
                  <li>de renforcer votre lien
                  </li>
                  <li>de vivre la grossesse en pleine conscience

                  </li>
                  <li>d’accompagner bébé tout au long des étapes de sa naissance

                  </li>
                </ul>
                <strong>Après la naissance</strong>, il permet : <br /> <br />
                <ul>
                  <li>de mieux comprendre les besoins et difficultés de votre enfant
                  </li>
                  <li>d’améliorer vos échanges par des paroles adaptées
                  </li>
                  <li>d’approfondir votre complicité
                  </li>
                  <li>de l’aider à réaliser ses challenges

                  </li>
                </ul>
                Je remercie les parents de <strong>Mathis, Bébé-Boule-de-Joie</strong> et <strong>Louna</strong> qui ont accepté de vous faire partager les paroles d'âme de leur enfant. <br /><br />
                <strong>Ilyes</strong>, lui, a souhaité m'éclairer sur l'Amour et la Différence : une magnifique réflexion sur l'Amour Inconditionnel. <br /><br />
                <div className='meditation-titre'> Apprenons de nos enfants, ils sont nos maîtres ... </div></p>

            </div>
          </Col>
          <Col xs={12} lg={3}>
            <div className='right-block'>
              <h4 align="center" class="style5"><strong>Bébé-Channeling : <br /> Extraits</strong></h4>

            </div>
            <Link to={'/accueil-nouveaux-nes/mathis'} style={{ textDecoration: 'none' }}>
              <div className='right-block right-block-margin-2'>
                <div className='nouveau-bebe-info'>
                  <p>
                    <h5><strong>Mathis : </strong></h5>
                    <i>"Familles Universelles, je vous aime ..."</i> <br /><br />
                    <img src={mathis} className="nouveau-img" />
                  </p>
                </div>
              </div>
            </Link>

            <Link to={'/accueil-nouveaux-nes/bebe-boule-de-joie'} style={{ textDecoration: 'none' }}>
              <div className='right-block right-block-margin-2'>
                <div className='nouveau-bebe-info'>
                  <p>
                    <h5><strong>Bébé-Boule-de-Joie : </strong></h5>
                    <i>"Je suis comme un tourbillon, là où je passe ..."</i> <br /><br />
                    <img src={mariloue} className="nouveau-img" />
                  </p>
                </div>
              </div>
            </Link>

            <Link to={'/accueil-nouveaux-nes/louna'} style={{ textDecoration: 'none' }}>
              <div className='right-block right-block-margin-2'>
                <div className='nouveau-bebe-info'>
                  <p>
                    <h5><strong>Louna : </strong></h5>
                    <i>"Je veux ouvrir des chemins là où il n'y en a pas ..."</i><br /><br />
                    <img src={louna} className="nouveau-img" />
                  </p>
                </div>
              </div>
            </Link>

            <Link to={'/accueil-nouveaux-nes/ilyes'} style={{ textDecoration: 'none' }}>
              <div className='right-block right-block-margin-2'>
                <div className='nouveau-bebe-info'>
                  <p>
                    <h5><strong>Ilyes : </strong></h5>
                    <i>" Je suis né avec un petit 'some' en plus ... vous appelez cela trisomique ...? "</i> <br /><br />
                    <img src={tc} className="nouveau-img" />
                  </p>
                </div>
              </div>
            </Link>


          </Col>
        </Row>
      </div>
    </>
  );
}

